export const ENTITY_TYPES = {
    LEAD: "LEAD",
    TASK: "TASK",
    CUSTOMER: "CUSTOMER",
};

export const WORKFLOW_PROCESS_TYPES = {
    TASK_AGING: "Process Task Aging Ist Nudge",
    LEAD_AGING: "Process Lead Aging Ist Nudge",
    EMAIL_TO_TASK_AUTO_RESPONSE: "Process Email To Task Auto Response",
    THIRD_PARTY_API: "Process 3rd Party API",
    MAP_API_TO_LEAD: "Map API Payload To Lead",
    PRODUCT_SPECIFIC_CUSTOMERS: "Process Product Specific Customers",
};

export const WORKFLOW_ACTION_TYPES = {
    SEND_EMAIL: "Send Email",
    UPDATE_TASK_ACTIVITY: "Update Task Activity",
    UPDATE_LEAD_FOLLOWUP: "Update Lead Followup",
    CREATE_LEAD: "Create Lead",
};

export const WORKFLOW_TAB_VALUES = {
    LIST: "TAB_WF_LIST",
    LOGS: "TAB_WF_LOGS",
};

export const workflowTabsConfig = [
    {
        value: WORKFLOW_TAB_VALUES.LIST,
        labelKey: WORKFLOW_TAB_VALUES.LIST,
        defaultLabel: "Workflows",
    },
    {
        value: WORKFLOW_TAB_VALUES.LOGS,
        labelKey: WORKFLOW_TAB_VALUES.LOGS,
        defaultLabel: "Execution Logs",
    },
];

export const WF_VIEW_TYPE_TABLE = "TABLE";
export const WF_VIEW_TYPE_KEY_VALUE = "KEY_VALUE";
export const WF_VIEW_TYPE_TEXT = "TEXT";

export const WORKFLOW_LOG_DATE_TIME_FORMAT = "DD MMM YYYY, HH:mm:ss";

export const WORKFLOW_LOG_RESULT_COLUMN_ORDER = [
    "status",
    "entityId",
    "sender",
    "recipient",
    "subject",
    "body",
    "followupId",
    "taskActivityId",
    "note",
    "errorMessage",
];

export const WORKFLOW_LOG_RESULT_HIDDEN_FIELDS = ["messageId", "errorMessage"];

export const WORKFLOW_LOG_RESULT_FIELD_LABELS = {
    status: "Status",
    entityId: "Entity ID",
    name: "Customer Name",
    customerEmail: "Customer Email",
    customer_email: "Customer Email",
    totalEligibleCount: "Total Customers Found",
    skippedNoEmailCount: "Skipped (No Email)",
    recordsPrepared: "Records Prepared",
    recordsToProcess: "Records To Process",
    attempted: "Attempted",
    successCount: "Success Count",
    failedCount: "Failed Count",
    reason: "Skip Reason",
    taskActivityId: "Activity ID",
    followupId: "Followup ID",
    sender: "Received from",
    recipient: "Sent To",
    subject: "Subject",
    body: "Body",
    note: "Note",
    errorMessage: "Error Detail",
};

export const WORKFLOW_TRIGGER_TYPES = {
    EVENT_BASED: "Event Based",
    DAILY_ONCE: "Time Based - Daily Once",
    DAILY_MULTIPLE: "Time Based - Daily Multiple Times",
    WEEKLY: "Time Based - Weekly",
    MONTHLY: "Time Based - Monthly",
    YEARLY: "Time Based - Yearly",
    BACKEND_TIME_BASED: "Time Based",
};

export const WORKFLOW_SCHEDULE_MODES = {
    SINGLE_DAILY: "SINGLE_DAILY",
    DAILY_MULTIPLE_TIMES: "DAILY_MULTIPLE_TIMES",
    WEEKLY: "WEEKLY",
    MONTHLY: "MONTHLY",
    YEARLY: "YEARLY",
};

export const THIRD_PARTY_PROVIDERS = {
    META: "Meta",
};

export const WORKFLOW_AUTH_TYPES = {
    OAUTH2: "OAuth2",
    BEARER: "Bearer",
    API_KEY: "API Key",
    NONE: "None",
};

export const WORKFLOW_HTTP_METHODS = {
    GET: "GET",
    POST: "POST",
};

export const WORKFLOW_API_KEY_LOCATIONS = {
    HEADER: "Header",
    QUERY_PARAM: "Query Param",
};

export const defaultProcessingConfig = { processing_type: "", days: "" };
export const defaultActionConfig = { action_type: "", emailDetails: null };

export const defaultApiAccessConfig = {
    provider: THIRD_PARTY_PROVIDERS.META,
    authType: WORKFLOW_AUTH_TYPES.OAUTH2,
    url: "",
    method: WORKFLOW_HTTP_METHODS.GET,
    authToken: "",
    apiKeyLocation: WORKFLOW_API_KEY_LOCATIONS.HEADER,
    apiKeyName: "",
    apiKeyValue: "",
    app_id: "",
    app_secret: "",
    short_lived_token: "",
    page_id: "",
    page_name: "",
    page_access_token: "",
    form_id: "",
    form_name: "",
    responseDataPath: "data",
};

export const workflowStatus = [
    { label: "WORKFLOW_STATUS_DRAFT" },
    { label: "WORKFLOW_STATUS_ACTIVE" },
    { label: "WORKFLOW_STATUS_INACTIVE" },
];

export const workflowTriggerTypes = [
    { label: WORKFLOW_TRIGGER_TYPES.EVENT_BASED, value: WORKFLOW_TRIGGER_TYPES.EVENT_BASED },
    { label: WORKFLOW_TRIGGER_TYPES.DAILY_ONCE, value: WORKFLOW_TRIGGER_TYPES.DAILY_ONCE },
    { label: WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE, value: WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE },
    { label: WORKFLOW_TRIGGER_TYPES.WEEKLY, value: WORKFLOW_TRIGGER_TYPES.WEEKLY },
    { label: WORKFLOW_TRIGGER_TYPES.MONTHLY, value: WORKFLOW_TRIGGER_TYPES.MONTHLY },
    { label: WORKFLOW_TRIGGER_TYPES.YEARLY, value: WORKFLOW_TRIGGER_TYPES.YEARLY },
];

export const searchWorkflowTriggerTypes = [
    { label: WORKFLOW_TRIGGER_TYPES.EVENT_BASED, value: WORKFLOW_TRIGGER_TYPES.EVENT_BASED },
    { label: WORKFLOW_TRIGGER_TYPES.BACKEND_TIME_BASED, value: WORKFLOW_TRIGGER_TYPES.BACKEND_TIME_BASED },
];

export const workflowDailyFrequencies = [
    { label: "2 times (Every 12 hours)", value: 2 },
    { label: "4 times (Every 6 hours)", value: 4 },
    { label: "6 times (Every 4 hours)", value: 6 },
    { label: "12 times (Every 2 hours)", value: 12 },
    { label: "24 times (Every hour)", value: 24 }
];

export const workflowEventTypes = [
    { label: "Task Creation", value: "TASK_CREATED" },
];

export const workflowProcessingTypes = [
    { label: WORKFLOW_PROCESS_TYPES.TASK_AGING, value: WORKFLOW_PROCESS_TYPES.TASK_AGING },
    { label: WORKFLOW_PROCESS_TYPES.LEAD_AGING, value: WORKFLOW_PROCESS_TYPES.LEAD_AGING },
    { label: WORKFLOW_PROCESS_TYPES.EMAIL_TO_TASK_AUTO_RESPONSE, value: WORKFLOW_PROCESS_TYPES.EMAIL_TO_TASK_AUTO_RESPONSE },
    { label: WORKFLOW_PROCESS_TYPES.THIRD_PARTY_API, value: WORKFLOW_PROCESS_TYPES.THIRD_PARTY_API },
    { label: WORKFLOW_PROCESS_TYPES.MAP_API_TO_LEAD, value: WORKFLOW_PROCESS_TYPES.MAP_API_TO_LEAD },
    { label: WORKFLOW_PROCESS_TYPES.PRODUCT_SPECIFIC_CUSTOMERS, value: WORKFLOW_PROCESS_TYPES.PRODUCT_SPECIFIC_CUSTOMERS },
];

export const workflowActionType = [
    { label: WORKFLOW_ACTION_TYPES.SEND_EMAIL, value: WORKFLOW_ACTION_TYPES.SEND_EMAIL },
    { label: WORKFLOW_ACTION_TYPES.UPDATE_TASK_ACTIVITY, value: WORKFLOW_ACTION_TYPES.UPDATE_TASK_ACTIVITY, entityType: ENTITY_TYPES.TASK },
    { label: WORKFLOW_ACTION_TYPES.UPDATE_LEAD_FOLLOWUP, value: WORKFLOW_ACTION_TYPES.UPDATE_LEAD_FOLLOWUP, entityType: ENTITY_TYPES.LEAD },
    { label: WORKFLOW_ACTION_TYPES.CREATE_LEAD, value: WORKFLOW_ACTION_TYPES.CREATE_LEAD, entityType: ENTITY_TYPES.LEAD },
];

export const workflowHttpMethods = [
    { label: WORKFLOW_HTTP_METHODS.GET, value: WORKFLOW_HTTP_METHODS.GET },
    { label: WORKFLOW_HTTP_METHODS.POST, value: WORKFLOW_HTTP_METHODS.POST },
];

export const workflowAuthTypes = [
    { label: "OAuth 2.0", value: WORKFLOW_AUTH_TYPES.OAUTH2 },
];

export const workflowApiKeyLocations = [
    { label: WORKFLOW_API_KEY_LOCATIONS.HEADER, value: WORKFLOW_API_KEY_LOCATIONS.HEADER },
    { label: WORKFLOW_API_KEY_LOCATIONS.QUERY_PARAM, value: WORKFLOW_API_KEY_LOCATIONS.QUERY_PARAM },
];

export const workflowProviderConfigs = {
    [THIRD_PARTY_PROVIDERS.META]: {
        label: THIRD_PARTY_PROVIDERS.META,
        value: THIRD_PARTY_PROVIDERS.META,
        authTypes: [WORKFLOW_AUTH_TYPES.OAUTH2],
        supportsGenericApiForm: false,
    },
};

export const workflowThirdPartyProviders = Object.values(workflowProviderConfigs).map(({ label, value }) => ({
    label,
    value,
}));

export const getWorkflowProviderConfig = (provider) => workflowProviderConfigs[provider] || null;

export const getWorkflowAuthTypesForProvider = (provider) => {
    const providerConfig = getWorkflowProviderConfig(provider);
    const allowedAuthTypes = providerConfig?.authTypes || [];
    return workflowAuthTypes.filter(authType => allowedAuthTypes.includes(authType.value));
};

export const isMetaOAuthConfig = (config) => {
    return config?.provider === THIRD_PARTY_PROVIDERS.META && config?.authType === WORKFLOW_AUTH_TYPES.OAUTH2;
};

export const isTimeBasedTrigger = (triggerType) => {
    return [
        WORKFLOW_TRIGGER_TYPES.DAILY_ONCE,
        WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE,
        WORKFLOW_TRIGGER_TYPES.WEEKLY,
        WORKFLOW_TRIGGER_TYPES.MONTHLY,
        WORKFLOW_TRIGGER_TYPES.YEARLY,
        WORKFLOW_TRIGGER_TYPES.BACKEND_TIME_BASED,
    ].includes(triggerType);
};

export const toBackendTriggerType = (triggerType) => {
    return isTimeBasedTrigger(triggerType) ? WORKFLOW_TRIGGER_TYPES.BACKEND_TIME_BASED : triggerType;
};

export const getScheduleModeFromTrigger = (triggerType) => {
    if (triggerType === WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE) return WORKFLOW_SCHEDULE_MODES.DAILY_MULTIPLE_TIMES;
    return WORKFLOW_SCHEDULE_MODES.SINGLE_DAILY;
};

/**
 * Maps a UI trigger type to its schedule mode, or null if not a structured trigger.
 */
export const getTriggerMode = (triggerType) => {
    if (triggerType === WORKFLOW_TRIGGER_TYPES.WEEKLY)  return WORKFLOW_SCHEDULE_MODES.WEEKLY;
    if (triggerType === WORKFLOW_TRIGGER_TYPES.MONTHLY) return WORKFLOW_SCHEDULE_MODES.MONTHLY;
    if (triggerType === WORKFLOW_TRIGGER_TYPES.YEARLY)  return WORKFLOW_SCHEDULE_MODES.YEARLY;
    return null;
};

export const getTriggerTypeForUi = (backendTriggerType, triggerConfig = {}) => {
    if (backendTriggerType === WORKFLOW_TRIGGER_TYPES.BACKEND_TIME_BASED) {
        const mode = triggerConfig?.scheduleMode;
        if (mode === WORKFLOW_SCHEDULE_MODES.DAILY_MULTIPLE_TIMES) return WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE;
        if (mode === WORKFLOW_SCHEDULE_MODES.WEEKLY) return WORKFLOW_TRIGGER_TYPES.WEEKLY;
        if (mode === WORKFLOW_SCHEDULE_MODES.MONTHLY) return WORKFLOW_TRIGGER_TYPES.MONTHLY;
        if (mode === WORKFLOW_SCHEDULE_MODES.YEARLY) return WORKFLOW_TRIGGER_TYPES.YEARLY;
        return WORKFLOW_TRIGGER_TYPES.DAILY_ONCE;
    }
    return backendTriggerType;
};


export const getActionEntityType = (actionType) => {
    return workflowActionType.find(action => action.value === actionType)?.entityType || null;
};

export const getProcessingEntityType = (processingType) => {
    if ([
        WORKFLOW_PROCESS_TYPES.LEAD_AGING,
        WORKFLOW_PROCESS_TYPES.MAP_API_TO_LEAD,
        WORKFLOW_PROCESS_TYPES.THIRD_PARTY_API,
    ].includes(processingType)) {
        return ENTITY_TYPES.LEAD;
    }
    if ([
        WORKFLOW_PROCESS_TYPES.TASK_AGING,
        WORKFLOW_PROCESS_TYPES.EMAIL_TO_TASK_AUTO_RESPONSE,
    ].includes(processingType)) {
        return ENTITY_TYPES.TASK;
    }
    if (processingType === WORKFLOW_PROCESS_TYPES.PRODUCT_SPECIFIC_CUSTOMERS) {
        return ENTITY_TYPES.CUSTOMER;
    }
    return null;
};

export const validateWorkflowApiAccess = (config) => {
    let newErrors = {};
    let hasError = false;

    if (isMetaOAuthConfig(config)) {
        if (!config.page_id) {
            newErrors.page_id = true;
            hasError = true;
        }
        if (!config.form_id) {
            newErrors.form_id = true;
            hasError = true;
        }
    } else {
        if (!config.url) {
            newErrors.url = true;
            hasError = true;
        }
        if (config.authType === WORKFLOW_AUTH_TYPES.BEARER && !config.authToken) {
            newErrors.authToken = true;
            hasError = true;
        }
        if (config.authType === WORKFLOW_AUTH_TYPES.API_KEY) {
            if (!config.apiKeyName) {
                newErrors.apiKeyName = true;
                hasError = true;
            }
            if (!config.apiKeyValue) {
                newErrors.apiKeyValue = true;
                hasError = true;
            }
        }
    }

    return { newErrors, hasError };
};

export const formatCamelCaseToTitle = (text) => {
    if (!text) return '';
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
};

export const WEEK_DAYS_OPTIONS = [
    { name: 'Monday',    value: 'MONDAY'    },
    { name: 'Tuesday',   value: 'TUESDAY'   },
    { name: 'Wednesday', value: 'WEDNESDAY' },
    { name: 'Thursday',  value: 'THURSDAY'  },
    { name: 'Friday',    value: 'FRIDAY'    },
    { name: 'Saturday',  value: 'SATURDAY'  },
    { name: 'Sunday',    value: 'SUNDAY'    },
];

export const MONTH_DATES_OPTIONS = Array.from({ length: 31 }, (_, i) => ({
    name: String(i + 1),
    value: i + 1
}));

/** Zero-padded day options for the YEARLY trigger date dropdown. */
export const YEARLY_DAY_OPTIONS = Array.from({ length: 31 }, (_, i) => ({
    label: String(i + 1),
    value: String(i + 1).padStart(2, "0"),
}));

export const MONTHS = [
    { label: 'January',   value: '01' },
    { label: 'February',  value: '02' },
    { label: 'March',     value: '03' },
    { label: 'April',     value: '04' },
    { label: 'May',       value: '05' },
    { label: 'June',      value: '06' },
    { label: 'July',      value: '07' },
    { label: 'August',    value: '08' },
    { label: 'September', value: '09' },
    { label: 'October',   value: '10' },
    { label: 'November',  value: '11' },
    { label: 'December',  value: '12' },
];

export const getYearlyDateLabel = (dateStr) => {
    if (!dateStr || !dateStr.includes('-')) return dateStr;
    const [m, d] = dateStr.split("-");
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthIndex = parseInt(m, 10) - 1;
    if (monthIndex < 0 || monthIndex > 11) return dateStr;
    return `${monthNames[monthIndex]} ${parseInt(d, 10)}`;
};

/**
 * Returns true if a yearly date string is a complete "MM-DD" pair.
 * Uses the same split-based logic used across the codebase.
 */
export const isValidYearlyDate = (dateStr) =>
    typeof dateStr === 'string' && dateStr.includes('-') && dateStr.split('-')[0] && dateStr.split('-')[1];

/**
 * Filters a scheduleDates array down to only valid "MM-DD" entries.
 */
export const filterValidYearlyDates = (dates) =>
    (dates || []).filter(isValidYearlyDate);

/**
 * Builds the triggerConfig payload object for backend submission.
 * Pure function — receives wfDetails and triggerMode as parameters.
 */
export const buildTriggerConfig = (wfDetails, triggerMode) => {
    if (wfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.EVENT_BASED) {
        return { event: wfDetails?.event };
    }
    if (triggerMode) {
        return {
            scheduleMode: triggerMode,
            time: wfDetails?.structuredTime?.format
                ? wfDetails.structuredTime.format('hh:mm A')
                : null,
            ...(triggerMode === WORKFLOW_SCHEDULE_MODES.WEEKLY
                ? { days: (wfDetails.scheduleDays || []).map(d => d.value || d) }
                : {}),
            ...((triggerMode === WORKFLOW_SCHEDULE_MODES.MONTHLY ||
                 triggerMode === WORKFLOW_SCHEDULE_MODES.YEARLY)
                ? { dates: triggerMode === WORKFLOW_SCHEDULE_MODES.YEARLY
                    ? filterValidYearlyDates(wfDetails.scheduleDates)
                    : (wfDetails.scheduleDates || []).map(d => d.value || d)
                  }
                : {}),
        };
    }
    return {
        scheduleMode: getScheduleModeFromTrigger(wfDetails?.triggerType),
        ...(wfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE
            ? { timesPerDay: wfDetails?.timesPerDay } : {}),
        ...(wfDetails?.runtime ? { runtime: wfDetails.runtime } : {}),
    };
};

/**
 * Updates a specific row's date string ("MM-DD") in the yearly schedule dates array.
 * Pure function returning the new dates array.
 */
export const updateYearlyDate = (scheduleDates = [], index, field, value) => {
    const nextDates = [...(scheduleDates || [])];
    while (nextDates.length <= index) {
        nextDates.push("");
    }
    const currentVal = nextDates[index] || "";
    const parts = currentVal.split("-");
    let m = parts[0] || "";
    let d = parts[1] || "";
    if (field === "month") {
        m = value;
    } else if (field === "date") {
        d = value;
    }
    nextDates[index] = `${m}-${d}`;
    return nextDates;
};

/**
 * Validates trigger configuration based on selected triggerType.
 * Pure function receiving currentWfDetails object.
 */
export const isTriggerValid = (wfDetails) => {
    if (!wfDetails?.triggerType) return false;
    const tt = wfDetails.triggerType;
    if (tt === WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE) return !!wfDetails?.timesPerDay;
    if (tt === WORKFLOW_TRIGGER_TYPES.DAILY_ONCE)     return !!wfDetails?.time;
    if (tt === WORKFLOW_TRIGGER_TYPES.WEEKLY || tt === WORKFLOW_TRIGGER_TYPES.MONTHLY || tt === WORKFLOW_TRIGGER_TYPES.YEARLY) {
        if (!wfDetails?.structuredTime) return false;
        if (tt === WORKFLOW_TRIGGER_TYPES.WEEKLY)  return (wfDetails?.scheduleDays  || []).length > 0;
        if (tt === WORKFLOW_TRIGGER_TYPES.MONTHLY) return (wfDetails?.scheduleDates || []).length > 0;
        if (tt === WORKFLOW_TRIGGER_TYPES.YEARLY) {
            const dates = wfDetails?.scheduleDates || [];
            if (dates.length === 0) return false;
            return dates.every(isValidYearlyDate);
        }
    }
    if (tt === WORKFLOW_TRIGGER_TYPES.EVENT_BASED) return !!wfDetails?.event;
    return true;
};

